import axiosClient from './axiosClient';
const BanDoThichHopApi = {
    getAll: () => {
        const url = '/bandothichhop/getall';
        return axiosClient.get(url)
    },
    getPaging: (params) => {
        const url = '/mappublic/gettimkiem';
        return axiosClient.get(url, { params });
    },
    delete: (str) => {
        const url = '/bandothichhop/delete?str=' + str;
        return axiosClient.delete(url);
    },

    update: (data) => {
        const url = '/bandothichhop/edit';
        return axiosClient.put(url, data);
    },

    addGeo: (data) => {
        const url = '/bandothichhop/add';
        return axiosClient.post(url, data);
    },

    updateThongTin: (data) => {
        const url = '/bandothichhop/editthongtin';
        return axiosClient.put(url, data);
    },
    addThongTin: (data) => {
        const url = '/bandothichhop/addthongtin';
        return axiosClient.post(url, data);
    },
}
export default BanDoThichHopApi;